import { render, staticRenderFns } from "./NoticeMsg.vue?vue&type=template&id=51368686&scoped=true"
import script from "./NoticeMsg.vue?vue&type=script&lang=js"
export * from "./NoticeMsg.vue?vue&type=script&lang=js"
import style0 from "./NoticeMsg.vue?vue&type=style&index=0&id=51368686&prod&rel=stylesheet%2Fscss&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51368686",
  null
  
)

export default component.exports